module.exports = __webpack_public_path__ + "static/shogai-4f76e18a82c9760e8d28ffd76f7ce97f.png";